export default __webpack_public_path__ + "assets/img/app_on_mobile.svg";